import * as adwords from './adwords';
import * as googleAnalytics from './googleAnalytics';
import * as yoTrack from './yoTrack';
import * as conversionPixel from './conversionPixel';

function getTracker(aftType) {
  if (aftType == null || aftType === 'google') {
    return googleAnalytics;
  }
  if (aftType === 'adwords') {
    return adwords;
  }
  if (aftType === 'yotrack') {
    return yoTrack;
  }

  if (aftType === 'conversionPixel') {
    return conversionPixel;
  }
  return null;
}

function runPageTracker(aftId, aftType) {
  if (!aftId) return Promise.resolve();
  const tracker = getTracker(aftType);
  if (!tracker) return Promise.resolve();
  return tracker.trackPage(aftId);
}

function runEventTracker(aftId, aftType, event, properties) {
  if (!aftId || !event) return Promise.resolve();
  const tracker = getTracker(aftType);
  if (!tracker) return Promise.resolve();
  return tracker.trackEvent(aftId, event, properties);
}

export async function trackAffiliatePage({ aftId, aftType, aft }) {
  if (aft) {
    return Promise.all(aft.map(({ id, type }) => runPageTracker(id, type)));
  }
  return runPageTracker(aftId, aftType);
}

export async function trackAffiliateEvent({ aftId, aftType, aft, event, properties }) {
  if (aft) {
    return Promise.all(aft.map(({ id, type }) => runEventTracker(id, type, event, properties)));
  }
  return runEventTracker(aftId, aftType, event, properties);
}
